import placeholder from "../assets/team/person.png"
import CT_dhanya from "../assets/team/CT_dhanya.png"
import shilpi_img from "../assets/team/shilpi.png"
import puru_img from "../assets/team/puru.jpg"
import abhay_img from "../assets/team/abhay_thakur.png"
import gaurav_img from "../assets/team/gaurav.jpg"
import saksham_img from "../assets/team/saksham.jpg"
import nirmal_img from "../assets/team/nirmal.jpg"
import ajay_img from "../assets/team/ajay.jpg"
import abhinav_img from "../assets/team/abhinav.jpg"
import nidhi_img from "../assets/team/nidhi.jpg"
import shivani_img from "../assets/team/shivani.jpg"
import arush_img from "../assets/team/arush.jpg"

const team_members = {
    "faculty_head": [
        {
            "name": "Prof. Dhanya C. T.", 
            "role": "Dean (Academics)",
            "image": CT_dhanya
        },
        {
            "name": "Prof. Shilpi Sharma",
            "role": "Associate Dean Academics (Outreach & New Initiatives)",
            "image": shilpi_img
        }
    ],
    "staff_members": [
        {
            "name": "Saksham",
            "role": "Staff Member, IIT Delhi",
            "image": saksham_img
        },
        {
            "name": "Gaurav",
            "role": "Staff Member, IIT Delhi",
            "image": gaurav_img
        },
        {
            "name": "Nirmal",
            "role": "Staff Member, IIT Delhi",
            "image": nirmal_img
        },
        {
            "name": "Ajay",
            "role": "Staff Member, IIT Delhi",
            "image": ajay_img
        },
        {
            "name": "Abhinav",
            "role": "Staff Member, IIT Delhi",
            "image": abhinav_img
        },
        {
            "name": "Renu",
            "role": "Staff Member, IIT Delhi",
            "image": placeholder
        },
        {
            "name": "Nidhi",
            "role": "Jr. Assistant, IIT Delhi",
            "image": nidhi_img
        },
        {
            "name": "Shivani",
            "role": "Consultant, IIT Delhi",
            "image": shivani_img
        }
    ],
    "student_members": [
        {
            "vertical": "Secretaries",
            "members": [
                {
                    "name": "Abhay Thakur",
                    "role": "General Secretary, IIT Delhi",
                    "image": abhay_img
                },
                {
                    "name": "Arush Ramachandran",
                    "role": "Deputy General Secretary, IIT Delhi",
                    "image": arush_img
                }
            ]
        },
        {
            "vertical": "Technical",
            "members": [
                {
                    "name": "Aman",
                    "role": "Technical Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Rahul",
                    "role": "Technical Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Raj",
                    "role": "Technical Member, IIT Delhi",
                    "image": placeholder
                }
            ]
        },
        {
            "vertical": "Design",
            "members": [
                {
                    "name": "Sakshi",
                    "role": "Design Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Riya",
                    "role": "Design Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Saksham",
                    "role": "Design Member, IIT Delhi",
                    "image": placeholder
                }
            ]
        },
        {
            "vertical": "Management",
            "members": [
                {
                    "name": "Aman",
                    "role": "Management Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Rahul",
                    "role": "Management Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Raj",
                    "role": "Management Member, IIT Delhi",
                    "image": placeholder
                }
            ]
        }
    ]
}

export default team_members;